module.exports = __webpack_public_path__ + "img/X-doesnotbelong.8f942391.svg";